const useCorrectCustomers = (customers) => {
  return (
    customers &&
    [...customers]
      .filter((customer) => !customer.hided)
      .sort(
        (firstCustomer, secondCustomer) =>
          firstCustomer.prior - secondCustomer.prior
      )
  );
};

export default useCorrectCustomers;
